module.exports = __webpack_public_path__ + "img/series_03.987961b1.png";